import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import { put, takeLatest } from "redux-saga/effects";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  userSelectCustomerSubset: "userSelectCustomerSubset [Action]",
  userSelectCustomerSubsetLoading: "userSelectCustomerSubsetLoading [Action]",
  userSelectCustomerSubsetAsync: "userSelectCustomerSubsetAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const user_select_customer_subset_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.userSelectCustomerSubset:
      return {
        ...state,
        data: payload?.data?.results,
        total: payload?.total,
      };
    case actionTypes.userSelectCustomerSubsetLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.userSelectCustomerSubsetLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "marketer",
    method_type: "user_select_marketer_customers_subset",
    data: payload?.data ? payload.data : {},
    size: 10,
    from_: 0,
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.userSelectCustomerSubset,
      // payload: res?.data?.response?.data?.results,
      payload: res?.data?.response,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.userSelectCustomerSubsetLoading,
      payload: false,
    });
  }
}

export function* userSelectCustomerSubset() {
  yield takeLatest(actionTypes.userSelectCustomerSubsetAsync, handleWorker);
}
